/* tslint:disable */
/* eslint-disable */
/**
 * BusService
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { BusCityDto } from '../model';
// @ts-ignore
import { GetBusCityInfoResponseDto } from '../model';
// @ts-ignore
import { UpdateBusCityRequestDto } from '../model';
/**
 * BusCitiesApiGetAllBusCitiesGet - axios parameter creator
 * 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BusCitiesApiGetAllBusCitiesGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/GetAllBusCities`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BusCitiesApiGetBusCityInfoGet - axios parameter creator
 * 
 * @param {number} [busCityId] 
 * @param {string} [code] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BusCitiesApiGetBusCityInfoGetAxiosParamCreator (busCityId?: number, code?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/GetBusCityInfo`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (busCityId !== undefined) {
        localVarQueryParameter['busCityId'] = busCityId;
    }

    if (code !== undefined) {
        localVarQueryParameter['code'] = code;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * BusCitiesApiUpdateBusCityBusCityIdPut - axios parameter creator
 * 
 * @param {number} busCityId 
 * @param {UpdateBusCityRequestDto} [updateBusCityRequestDto] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function BusCitiesApiUpdateBusCityBusCityIdPutAxiosParamCreator (busCityId: number, updateBusCityRequestDto?: UpdateBusCityRequestDto, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    // verify required parameter 'busCityId' is not null or undefined
    assertParamExists('updateBusCityBusCityIdPut', 'busCityId', busCityId)
    const localVarPath = `/UpdateBusCity/{busCityId}`
        .replace(`{${"busCityId"}}`, encodeURIComponent(String(busCityId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(updateBusCityRequestDto, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for getBusCityInfoGet operation in BusCitiesApi.
 * @export
 * @interface BusCitiesApiGetBusCityInfoGetRequest
 */
export interface BusCitiesApiGetBusCityInfoGetRequest {
    /**
     * 
     * @type {number}
     * @memberof BusCitiesApiGetBusCityInfoGet
     */
    readonly busCityId?: number

    /**
     * 
     * @type {string}
     * @memberof BusCitiesApiGetBusCityInfoGet
     */
    readonly code?: string
}

/**
 * Request parameters for updateBusCityBusCityIdPut operation in BusCitiesApi.
 * @export
 * @interface BusCitiesApiUpdateBusCityBusCityIdPutRequest
 */
export interface BusCitiesApiUpdateBusCityBusCityIdPutRequest {
    /**
     * 
     * @type {number}
     * @memberof BusCitiesApiUpdateBusCityBusCityIdPut
     */
    readonly busCityId: number

    /**
     * 
     * @type {UpdateBusCityRequestDto}
     * @memberof BusCitiesApiUpdateBusCityBusCityIdPut
     */
    readonly updateBusCityRequestDto?: UpdateBusCityRequestDto
}

/**
* 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BusCitiesApiGetAllBusCitiesGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BusCitiesApiGetAllBusCitiesGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<Array<BusCityDto>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {BusCitiesApiGetBusCityInfoGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BusCitiesApiGetBusCityInfoGet(requestParameters: BusCitiesApiGetBusCityInfoGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BusCitiesApiGetBusCityInfoGetAxiosParamCreator(requestParameters.busCityId, requestParameters.code, options, configuration);
    const request: () => AxiosPromise<GetBusCityInfoResponseDto> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {BusCitiesApiUpdateBusCityBusCityIdPutRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function BusCitiesApiUpdateBusCityBusCityIdPut(requestParameters: BusCitiesApiUpdateBusCityBusCityIdPutRequest, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await BusCitiesApiUpdateBusCityBusCityIdPutAxiosParamCreator(requestParameters.busCityId, requestParameters.updateBusCityRequestDto, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
